import { render } from "./ModalBattlesSelect.vue?vue&type=template&id=35e1f451&scoped=true"
import script from "./ModalBattlesSelect.vue?vue&type=script&lang=js"
export * from "./ModalBattlesSelect.vue?vue&type=script&lang=js"

import "./ModalBattlesSelect.vue?vue&type=style&index=0&id=35e1f451&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e1f451"]])

export default __exports__